// extracted by mini-css-extract-plugin
var _1 = "BackLink-q2yfr";
var _2 = "Error-QThbe";
var _3 = "ErrorTitle-v46Jx";
export { _1 as "BackLink", _2 as "Error", _3 as "ErrorTitle" }
